import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Table, Card, Alert, Tag, Typography } from 'antd';
import { Link } from 'react-router-dom';
import apiClient from '@/services/api';

const { Title } = Typography;

interface VendorRow {
  vendorIdx: string;
  name: string;
  enabled: boolean;
  validFrom: string;
  validTo: string | null;
}

interface Resp {
  Result: string;
  count: number;
  vendors: VendorRow[];
}

export default function DistributorHome() {
  const { t } = useTranslation();
  const { data, isLoading, error } = useQuery({
    queryKey: ['distributor', 'vendors'],
    queryFn: async () => {
      const r = await apiClient.get<Resp>('/distributor/vendors');
      return r as unknown as Resp;
    },
  });

  return (
    <>
      <Title level={3} style={{ marginTop: 0 }}>
        {t('distributor.overview')}
      </Title>
      {error ? (
        <Alert type="error" message="Failed to load vendors" description={String(error)} />
      ) : (
        <Card title={`${t('distributor.relatedVendors')} (${data?.count ?? 0})`}>
          <Table
            size="small"
            rowKey="vendorIdx"
            loading={isLoading}
            dataSource={data?.vendors ?? []}
            pagination={{ pageSize: 20 }}
            columns={[
              {
                title: 'Vendor',
                dataIndex: 'name',
                key: 'name',
                render: (v: string, rec) => (
                  <Link to={`/distributor/vendors/${rec.vendorIdx}`}>{v}</Link>
                ),
              },
              {
                title: 'Status',
                dataIndex: 'enabled',
                key: 'enabled',
                width: 100,
                render: (v: boolean) =>
                  v ? <Tag color="green">Active</Tag> : <Tag>Disabled</Tag>,
              },
              {
                title: 'Since',
                dataIndex: 'validFrom',
                key: 'validFrom',
                render: (v: string) => new Date(v).toLocaleDateString(),
              },
              {
                title: 'UUID',
                dataIndex: 'vendorIdx',
                key: 'vendorIdx',
                render: (v: string) => <code style={{ fontSize: 11 }}>{v}</code>,
              },
            ]}
          />
        </Card>
      )}
    </>
  );
}
